import type { PropType, ExtractPublicPropTypes, VNode } from 'vue'
import {
  buttonProps as elButtonProps,
  // buttonEmits as elButtonEmits,
  type ButtonProps as ElButtonProps,
} from 'element-plus'
import { disabledProps } from '@el-plus/utils/props'
import type { VisibleProps, IDisabled } from '@el-plus/utils/props'
import type { TableScope } from '@el-plus/components/table'

export type ButtonProps<TClickArg = MouseEvent | TableScope> = Partial<
  Omit<ElButtonProps, 'disabled'> & {
    name: string
    prop: string // 唯一标识
    permission: string // 权限
    onClick: (e: TClickArg) => void
    scopedSlots: Record<string, () => VNode>
    disabled: IDisabled
    confirm: boolean
    confirmText: string
    confirmBefore: (e: TClickArg) => Promise<void>
  } & VisibleProps
>
export const buttonsProps = {
  ...elButtonProps,
  ...disabledProps,
  list: {
    type: Array as PropType<ButtonProps[]>,
    default: () => [],
  },
  size: {
    ...elButtonProps.size,
    default: 'small',
  },
  type: {
    ...elButtonProps.type,
    default: 'default',
  },
} as const
export type ButtonsProps = ExtractPublicPropTypes<typeof buttonsProps>
// export const buttonsEmits = {
//   ...elButtonEmits,
// }
// export type ButtonsEmits = typeof buttonsEmits
// export const buttonsEmitsKeys = Object.keys(buttonsEmits)
